import useBoolean from '@eduzz/houston-hooks/useBoolean';
import { Topbar } from '@eduzz/ui-layout';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import React, { useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';
import ModalFiscal from 'v2/components/Shared/ModalFiscal';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { profileFactory } from 'v2/services/profile';

const NoPartner = () => {
  const [modalFiscal, , openModalFiscal, closeModalFiscal] = useBoolean();

  useEffect(() => profileFactory.load(), []);
  const [profile] = useObservable(() => profileFactory.get(), []);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const onCompleteModalFiscal = useCallback(() => {
    closeModalFiscal();
    window.location.href = '/';
  }, [closeModalFiscal]);

  function handleOpenModalFiscal() {
    if (user.cannot_become_partner) {
      toast.error('Você já possui uma conta parceira ou ligada a um produto na Eduzz!');
      return;
    }

    openModalFiscal();
  }

  return (
    <>
      <Topbar.Action icon={<FlashOnIcon />} label='Quero Vender' onClick={handleOpenModalFiscal} />
      <ModalFiscal opened={modalFiscal} onClose={closeModalFiscal} onComplete={onCompleteModalFiscal} profile={profile} />
    </>
  );
};

export default NoPartner;
